import { render, staticRenderFns } from "./ManageMakeupComponent.vue?vue&type=template&id=598109e0&scoped=true&"
import script from "./ManageMakeupComponent.vue?vue&type=script&lang=js&"
export * from "./ManageMakeupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598109e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('598109e0')) {
      api.createRecord('598109e0', component.options)
    } else {
      api.reload('598109e0', component.options)
    }
    module.hot.accept("./ManageMakeupComponent.vue?vue&type=template&id=598109e0&scoped=true&", function () {
      api.rerender('598109e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/credits/components/ManageMakeupComponent.vue"
export default component.exports